import PropTypes from 'prop-types';
import { memo } from 'react';
import AdBasicDetails from '../../../../components/Assets/AdBasicDetails';
import Button from '../../../../components/Assets/Button';
import LogoButton from '../../../../components/Assets/LogoButton';
import Badge from '../../../../components/badge';
import {
  BadgeBackgroundColorEnum,
  BadgeTextColorEnum,
} from '../../../../components/badge/enums';
import IndividualCircularLoader from '../../../../components/Loader/IndividualCircularLoader';
import { APIStatus } from '../../../../services/axiosEnums';
import { euroFormat } from '../../../../utils/jsFunctions';
import useActiveAd from '../../hooks/useActiveAd';
import AdLoadErrorContent from '../adLoadErrorContent/AdLoadErrorContent';
import styles from './adDetails.module.scss';
import AdDetailsForms from './geo/adDetailsForms/AdDetailsForms';
import AdDetailsMapContainer from './geo/adDetailsMap/adDetailsMapContainer/AdDetailsMapContainer';
import SimilarPlotsResultContainer from './geo/similarPlotsResult/SimilarPlotsResultContainer';
import SimilarDpesResultContainer from './geo/similarDpesResult/SimilarDpesResultContainer';
import SimilarAds from './similarsAds/SimilarAds';
import { useAppSelector } from '../../../../App/redux/store';
import { getSelectedAdDetailsFormTabState } from '../../../../store/appManager/reducer';

interface IAdDetailsProps {
  adIdIri: string | null;
}
function AdDetails({ adIdIri }: IAdDetailsProps) {
  const { apiStatus, error, ad, createStudyFromAd, deleteAds } = useActiveAd({
    adIdIri,
  });
  const selectedAdDetailsFormTab = useAppSelector(getSelectedAdDetailsFormTabState);

  const handleFolder = () => {
    createStudyFromAd();
  };

  const handleDelete = () => {
    if (ad) {
      deleteAds(true);
    }
  };

  if (apiStatus === APIStatus.PENDING) {
    return <IndividualCircularLoader size={200} />;
  }

  if (apiStatus === APIStatus.REJECTED || !adIdIri) {
    return (
      <div className={styles.adDetails}>
        <AdLoadErrorContent />
      </div>
    );
  }

  return (
    <>
      {ad && (
        <div className={styles.adDetails}>
          <header className={styles.header}>
            <div className={styles.info}>
              <h2 className={styles.title}>
                {ad.totalRoom > 0
                  ? `${ad.propertyTypology.name} F${ad.totalRoom}`
                  : `${ad.propertyTypology.name}`}
                <Badge
                  badgeDynamicContent={
                    ad.price ? `${euroFormat(ad.price, true)} €` : 'Indéfini'
                  }
                  bgColor={BadgeBackgroundColorEnum.VIOLET}
                  textColor={BadgeTextColorEnum.WHITE}
                  isMini
                />
              </h2>
              <span className={styles.date}>{`Publiée le ${new Date(
                ad.publishedAt,
              ).toLocaleDateString()}`}</span>
            </div>
            <div className={styles.buttons}>
              <LogoButton
                btnType="button"
                handleClick={handleFolder}
                btnLogo="folder-wait"
                tooltip="A étudier"
              />
              <LogoButton
                btnType="button"
                handleClick={handleDelete}
                btnLogo="delete-red"
                tooltip="Supprimer"
              />
            </div>
          </header>

          <AdBasicDetails data={ad} />

          <Button
            className={styles.adLinkButton}
            btnType="button"
            btnContent="VOIR L'ANNONCE EN DETAILS"
            primary
            handleClick={() => window.open(ad.url, '_blank,noopener,noreferrer')}
          />

          <AdDetailsMapContainer />

          <AdDetailsForms ad={ad} />
          {selectedAdDetailsFormTab === 0 && (
            <SimilarPlotsResultContainer adCity={ad.city} />
          )}
          {selectedAdDetailsFormTab === 1 && (
            <SimilarDpesResultContainer adCity={ad.city} />
          )}

          <SimilarAds ad={ad} />
        </div>
      )}
    </>
  );
}

AdDetails.propTypes = {
  adId: PropTypes.string,
};

export default memo(AdDetails);
